<script lang="ts">import { afterNavigate } from "$app/navigation";
import { page } from "$app/stores";
import { cfgOptimoveEnabled, cfgOptimoveTenantId, cfgOptimoveTenantToken } from "@infinitro/config";
import { flushPendingOptimoveEvents, loggedIn, setOptimoveUserId, startOptimoveSdkFlushWatcher, statePlayerId, trackOptimovePageVisit } from "@infinitro/global";
import { onMount } from "svelte";
const optimoveEnabled = cfgOptimoveEnabled();
let lastIdentifiedPlayerId = $state(undefined);
let stopFlushWatcher;
const syncUserIdentity = () => {
	if (!$loggedIn || !$statePlayerId) {
		lastIdentifiedPlayerId = undefined;
		return;
	}
	if (lastIdentifiedPlayerId === $statePlayerId) return;
	setOptimoveUserId($statePlayerId);
	lastIdentifiedPlayerId = $statePlayerId;
};
const flushPendingEventsAndSyncIdentity = () => {
	void (async () => {
		const flushedPlayerId = await flushPendingOptimoveEvents();
		if (flushedPlayerId) {
			lastIdentifiedPlayerId = flushedPlayerId;
			return;
		}
		syncUserIdentity();
	})();
};
const logPageVisit = () => {
	trackOptimovePageVisit(window.location.href, document.title || "", $page.url.pathname);
};
const handleSdkLoad = () => {
	flushPendingEventsAndSyncIdentity();
};
$effect(() => {
	if (!optimoveEnabled || !$loggedIn) return;
	flushPendingEventsAndSyncIdentity();
});
onMount(() => {
	if (!optimoveEnabled) return;
	stopFlushWatcher = startOptimoveSdkFlushWatcher();
	logPageVisit();
	return () => {
		stopFlushWatcher?.();
	};
});
afterNavigate(() => {
	if (!optimoveEnabled) return;
	logPageVisit();
	syncUserIdentity();
});
</script>

<svelte:head>
	{#if optimoveEnabled}
		<script
			async
			onload={handleSdkLoad}
			src="https://sdk.optimove.net/v2/websdk/?tenant_id={cfgOptimoveTenantId()}&tenant_token={cfgOptimoveTenantToken()}"
		></script>
	{/if}
</svelte:head>
